export function isNullOrUndefined(value: number | undefined | null) {
    return value === undefined || value === null;
}
